/**
* Created by elmer on 12/07/17.
*/
<template>
    <i-form :model="form" ref="formEditarPublicidad" :rules="rules">
        <Form-item prop="nombre_archivo" label="Nombre">
            <i-input v-model="form.nombre_archivo" size="large"></i-input>
        </Form-item>
        <Form-item prop="descripcion" label="Descripción">
            <i-input v-model="form.descripcion" size="large" type="textarea" :rows="3"></i-input>
        </Form-item>
        <Form-item prop="texto_audio" label="Texto audio">
            <i-input v-model="form.texto_audio" size="large" type="textarea" :rows="3"></i-input>
        </Form-item>
        <Form-item prop="fecha_inicio" label="Período de vigencia">
            <Row type="flex" :gutter="15" style="clear: both;">
                <i-col :xs="12">
                    <Date-picker v-model="form.fecha_inicio" type="date" placement="top-end" format="dd-MMM" placeholder="Inicio de la vigencia"></Date-picker>
                </i-col>
                <i-col :xs="12">
                    <Date-picker v-model="form.fecha_fin" type="date" placement="top-end" format="dd-MMM" placeholder="Término de la vigencia"></Date-picker>
                </i-col>
            </Row>
        </Form-item>
        <Row type="flex" :gutter="10">
            <i-col :xs="24" :md="12">
                <Form-item label="Archivo actual" prop="archivo">
                    <span v-if="model.tipo_archivo === 'Foto'">
                        <img :src="model.archivo" :alt="model.nombre_archivo" style="width:100%;height:133px;object-fit: cover;" />
                    </span>
                    <span v-if="model.tipo_archivo === 'Video'">
                        <video style="width:100%;height:133px;" controls>
                            <source :src="model.archivo">
                        </video>
                    </span>
                </Form-item>
            </i-col>
            <i-col :xs="24" :md="12">
                <Form-item prop="files" label="Subir nuevo archivo">
                    <div v-if="form.files.length > 0" style="position:relative;">
                        <span v-if="fileType === 'Foto'">
                            <img :src="fileUrl" :alt="fileUrl" style="width:100%;height:133px;object-fit: cover;" />
                        </span>
                        <span v-if="fileType === 'Video'">
                            <video style="width:100%;height:133px;" controls>
                                <source :src="fileUrl">
                            </video>
                        </span>
                        <i-button @click="removeUpload" type="error" size="small" style="position: absolute;top:0;right:0;">
                            <Icon type="trash-a"></Icon>
                        </i-button>
                    </div>
                    <div v-show="!form.files.length > 0">
                        <Upload
                            type="drag"
                            :headers="uploadOpts.headers"
                            name="file"
                            :onSuccess="uploadOpts.onSuccess"
                            :onProgress="uploadOpts.onProgress"
                            :onError="uploadOpts.onError"
                            :onRemove="uploadOpts.onRemove"
                            :showUploadList="false"
                            ref="uploaderEdit"
                            style="clear:both;"
                            :action="uploadOpts.url">
                            <div style="padding: 20px 0">
                                <Icon type="ios-cloud-upload" size="52" style="color: #c3282b"></Icon>
                                <p>Arrastre aquí el archivo que desea agregar</p>
                            </div>
                        </Upload>
                    </div>
                </Form-item>
            </i-col>
        </Row>
        <Row type="flex" :gutter="10">
            <i-col :xs="24" :md="12">
                <i-button type="error" size="large" long :loading="isLoading" @click="cancel" icon="close-round">Cancelar</i-button>
            </i-col>
            <i-col :xs="24" :md="12">
                <i-button type="success" size="large" long :loading="isLoading" @click="onSubmit" icon="checkmark-round">Guardar</i-button>
            </i-col>
        </Row>
    </i-form>
</template>

<script>
  import moment from 'moment';
  import { getTipo } from '@/modules/admin/publicidad.utils';

  export default {
    data() {
      const self = this;
      return {
        isLoading: false,
        form: {
          nombre_archivo: '',
          descripcion: '',
          texto_audio: '',
          fecha_inicio: '',
          fecha_fin: '',
          files: [],
        },
        rules: {
          nombre_archivo: [
            { required: true, type: 'string', message: 'Este campo es requerido' },
          ],
          descripcion: [
            { type: 'string', message: 'Este campo es requerido' },
          ],
        },
        uploadOpts: {
          isUploading: false,
          url: `${process.env.API_URL}/api/catchFile?tabla=publicidad_archivos`,
          headers: {
            access_token: this.$store.state.jwt,
          },
          onSuccess(resp, file, fileList) {
            setTimeout(() => {
              if (self.uploadOpts.isUploading) {
                self.uploadOpts.isUploading();
                self.uploadOpts.isUploading = false;
              }
              self.form.files.push(resp[0].url_archivo_temporal);
            }, 5000);
          },
          onProgress(progress, file, fileList) {
            if (!self.uploadOpts.isUploading) {
              self.uploadOpts.isUploading = this.$Message.loading({
                duration: 0,
                content: 'Estamos subiendo el archivo...',
              });
            }
          },
          onError(err, file, fileList) {
            if (self.uploadOpts.isUploading) {
              self.uploadOpts.isUploading();
              self.uploadOpts.isUploading = false;
            }
            self.$Message.error('Ocurrió un error al enviar el archivo al servidor, inténtelo nuevamente');
          },
          onRemove(file, fileList) {
            self.form.files = fileList.filter(e => e.response && e.response.length)
              .map(e => e.response[0].url_archivo_temporal);
            const { nombre_temporal } = file.response[0];
            self.$store.dispatch('removeCatchedFile', { nombre_temporal });
              /* .then((resp) => {
                console.log('archivo eliminado', resp);
              }).catch((err) => {
                console.log('error al borrar archivo', err);
              }); */
          },
        },
      };
    },
    props: {
      model: {
        type: Object,
      },
    },
    methods: {
      parseModel() {
        const {
          nombre_archivo,
          descripcion,
          texto_audio,
          estado,
        } = this.model;
        this.form = {
          ...this.form,
          nombre_archivo,
          descripcion,
          texto_audio,
          fecha_inicio: this.model.fecha_inicio ? moment.tz(`${this.model.fecha_inicio} 00:00`, 'America/Merida').toDate() : null,
          fecha_fin: this.model.fecha_fin ? moment.tz(`${this.model.fecha_fin} 23:59`, 'America/Merida').toDate() : null,
          estado,
        };
        console.log(this.form);
      },
      cancel() {
        this.removeUpload();
        this.$emit('on-close');
      },
      onSubmit() {
        this.$refs.formEditarPublicidad.validate((valid) => {
          if (valid) {
            const { nombre_archivo, descripcion, texto_audio } = this.form;
            const payload = {
              id: this.model.id,
              form: {
                nombre_archivo,
                descripcion,
                texto_audio,
                fecha_inicio: this.form.fecha_inicio ? moment(this.form.fecha_inicio).format('YYYY-MM-DD') : null,
                fecha_fin: this.form.fecha_fin ? moment(this.form.fecha_fin).format('YYYY-MM-DD') : null,
              },
            };
            if (this.form.files.length > 0) {
              payload.form.archivo = this.form.files[0];
            }
            this.isLoading = true;
            this.$store.dispatch('editPublicidad', payload).then((resp) => {
              this.$emit('on-close');
              this.isLoading = false;
            }).catch((err) => {
              this.isLoading = false;
              this.$Message.error('Error al guardar los datos');
            });
          } else {
            this.$Message.error('Los datos del formulario son incorrectos');
          }
        });
      },
      removeUpload() {
        if (this.form.files.length > 0) {
          console.log(this.$refs);
          console.log(this.$refs.uploaderEdit);
          this.$refs.uploaderEdit.handleRemove(this.$refs.uploaderEdit.fileList[0]);
          this.form.files = [];
        }
      },
    },
    created() {
      // console.log('created', this.model);
      this.parseModel();
    },
    watch: {
      value(val) {
        this.model = val;
      },
      model() {
        this.$emit('input', this.model);
        this.parseModel();
      },
    },
    computed: {
      fileType() {
        if (this.form.files.length > 0) {
          return getTipo(this.form.files[0]);
        }
        return '';
      },
      fileUrl() {
        if (this.form.files.length > 0) {
          return `${process.env.API_URL}/${this.$refs.uploaderEdit.fileList[0].response[0].url_archivo_temporal}`;
        }
        return '';
      },
    },
  };
</script>



// WEBPACK FOOTER //
// PublicidadEditForm.vue?4f1ef568